<template>
  <nav class="menu" :class="{ float }">
    <NavLink class="link" href="/explore">Explore</NavLink>
    <NavLink class="link" href="/about">About</NavLink>
    <NavLink class="link" href="/en/magazine/">Magazine</NavLink>
    <NavLink class="link" href="/about#contact_us">Contact</NavLink>
  </nav>
</template>

<script setup>
import NavLink from '@/components/NavLink.vue'

defineProps({
  float: {
    type: Boolean,
    default: false,
  },
})
</script>

<style lang="scss" scoped>
.menu {
  border: 2px solid #f6f6f6;
  display: flex;
  border-radius: 30px;

  &:hover .link {
    color: $grey-100;
  }

  .link {
    padding: 12px 20px;
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
    border-radius: 30px;

    &:hover {
      color: $grey-300;
      background-color: $grey-25;
    }
  }
}

.menu.float {
  border: none;

  .link:hover {
    background-color: $grey-25;
  }
}
</style>
